/* ============================================================
   Custom Design page behavior — Skeie's Jewelers
   ------------------------------------------------------------
   One shared file for every custom-design-* section:
     1. Scroll reveals (.reveal)
     2. Meet the Designer video player
     3. Process scroll-scrubbed transformation
   Each block checks that its section exists before running, so
   sections can be re-ordered or removed freely. The init guard
   below keeps it safe when several sections load this file.
   ============================================================ */
(function(){
  if (window.__skeiesCustomDesignInit) return;
  window.__skeiesCustomDesignInit = true;

(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;

  /* ---------- gentle scroll reveal ---------- */
  if(!reduce && 'IntersectionObserver' in window){
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
    },{threshold:.12, rootMargin:'0px 0px -8% 0px'});
    document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); });
  }


  /* ---------- MEET THE DESIGNER video ---------- */
  var vframe=document.getElementById('vframe');
  var v=document.getElementById('meetVideo');
  if(vframe && v){
    var play=document.getElementById('vPlay'),
        toggle=document.getElementById('vToggle'),
        muteBtn=document.getElementById('vMute'),
        icM=document.getElementById('icMuted'), icU=document.getElementById('icUnmuted'),
        prog=document.getElementById('vProg'), progFill=document.getElementById('vProgFill');
    v.muted=true;
    function start(){
      var p=v.play();
      if(p && p.catch){ p.catch(function(){}); }
      vframe.classList.add('playing'); vframe.dataset.state='playing';
    }
    play.addEventListener('click', start);
    toggle.addEventListener('click', function(){
      if(v.paused){ start(); toggle.setAttribute('aria-label','Pause video'); }
      else { v.pause(); toggle.setAttribute('aria-label','Play video'); vframe.dataset.state='paused'; }
    });
    muteBtn.addEventListener('click', function(){
      v.muted=!v.muted;
      icM.style.display=v.muted?'block':'none';
      icU.style.display=v.muted?'none':'block';
      muteBtn.setAttribute('aria-label', v.muted?'Unmute video':'Mute video');
    });
    v.addEventListener('timeupdate', function(){
      if(v.duration) progFill.style.width=((v.currentTime/v.duration)*100)+'%';
    });
    prog.addEventListener('click', function(e){
      var r=prog.getBoundingClientRect();
      if(v.duration) v.currentTime=((e.clientX-r.left)/r.width)*v.duration;
    });
    v.addEventListener('ended', function(){
      vframe.classList.remove('playing'); vframe.dataset.state='idle';
    });
  }
})();

/*
  Image setup
  -----------
  PROCESS_IMAGES are the large left-side lifestyle/process photos.
  RING_IMAGES are the transparent PNG ring stages that replace the old large "01" number.

  Suggested file setup:
  - 0.jpg through 5.jpg = process/lifestyle photos
  - 0.png through 5.png = transparent ring PNGs
*/
var PROCESS_IMAGES = window.CD_PROCESS_IMAGES || ["0.jpg","1.jpg","2.jpg","3.jpg","4.jpg","5.jpg"];
// Stage 1 has no ring yet. The first PNG appears at Stage 2.
// File setup: 0.png through 4.png = transparent ring PNGs for stages 2 through 6.
var RING_IMAGES = window.CD_RING_IMAGES || [null,"1.png","2.png","3.png","4.png","5.png"];

(function(){
  var STAGES = [
    {
      t:"The Conversation",
      m:"Personal consultation, Eugene showroom",
      lbl:"Consult",
      b:"It starts with what the piece should mean. Bring a sketch, a photo, an heirloom, or just an idea, and we shape the direction together.",
      ic:'<path d="M21 11.5a8.4 8.4 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.7a8.4 8.4 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.4 8.4 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>'
    },
    {
      t:"The Sketch",
      m:"Concept, proportion and style",
      lbl:"Sketch",
      b:"Your idea takes its first visible form, rendered by hand until it reflects both your vision and the way you will actually wear it.",
      ic:'<path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4z"/>'
    },
    {
      t:"The Digital Model",
      m:"Precision before production",
      lbl:"Model",
      b:"A precise 3D model lets you review scale, profile, and prong placement, and approve every detail before anything is made.",
      ic:'<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><path d="M3.3 7l8.7 5 8.7-5"/><path d="M12 22V12"/>'
    },
    {
      t:"The Wax Model",
      m:"A preview you can hold",
      lbl:"Wax",
      b:"The digital design becomes a wax you can hold, confirming size and presence in the hand before a gram of metal is committed.",
      ic:'<circle cx="12" cy="14.5" r="6.2"/><path d="M8.6 9l3.4-6 3.4 6"/>'
    },
    {
      t:"The Casting",
      m:"Formed in precious metal",
      lbl:"Cast",
      b:"The approved model is cast in your chosen metal, with its true form but still raw, ready for setting and finishing by hand.",
      ic:'<path d="M12 3c.4 3.2 5 4.8 5 9.2A5 5 0 0 1 7 12.2C7 9.8 8.4 9 8.7 7.3 10.8 8 11 5.4 12 3z"/>'
    },
    {
      t:"The Finished Piece",
      m:"Set, polished and ready to wear",
      lbl:"Finish",
      b:"Stones are set, every surface refined, and the piece polished and inspected, ready to be carried forward as part of your story.",
      ic:'<path d="M6 3h12l3.5 5.5L12 21 2.5 8.5z"/><path d="M2.6 8.5h18.8"/><path d="M9 3 7 8.5 12 21l5-12.5L15 3"/>'
    }
  ];

  var N = STAGES.length;
  var reduce = window.matchMedia("(prefers-reduced-motion:reduce)").matches;

  function clamp(v,a,b){
    return Math.min(b,Math.max(a,v));
  }

  function ease(t){
    return t < .5 ? 2*t*t : 1 - Math.pow(-2*t + 2,2) / 2;
  }

  function makePlaceholder(i,type){
    var s = STAGES[i] || {lbl:"Stage " + (i+1)};
    var label = type === "ring" ? "RING PNG" : "PROCESS IMAGE";
    var ratio = type === "ring" ? "0 0 500 500" : "0 0 400 500";
    var width = type === "ring" ? "500" : "400";
    var height = "500";
    var stage = String(s.lbl || ("Stage " + (i+1))).toUpperCase();

    var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="' + ratio + '">' +
      '<rect width="' + width + '" height="' + height + '" fill="#1c170d"/>' +
      '<rect x="12" y="12" width="' + (parseInt(width,10)-24) + '" height="' + (parseInt(height,10)-24) + '" fill="none" stroke="#3d3520"/>' +
      '<text x="' + (parseInt(width,10)/2) + '" y="230" fill="#7c6a3c" font-family="Georgia,serif" font-style="italic" font-size="72" text-anchor="middle">' + (i+1) + '</text>' +
      '<text x="' + (parseInt(width,10)/2) + '" y="282" fill="#cdb57f" font-family="Helvetica,Arial,sans-serif" font-size="15" letter-spacing="3" text-anchor="middle">' + label + '</text>' +
      '<text x="' + (parseInt(width,10)/2) + '" y="312" fill="#8f7d4f" font-family="Helvetica,Arial,sans-serif" font-size="13" letter-spacing="2" text-anchor="middle">' + stage + '</text>' +
      '</svg>';

    return "data:image/svg+xml," + encodeURIComponent(svg);
  }

  function attachFallback(im,i,type){
    im.addEventListener("error",function onerr(){
      im.removeEventListener("error",onerr);
      im.src = makePlaceholder(i,type);
    });
  }

  document.querySelectorAll("[data-process-i]").forEach(function(im){
    var i = +im.getAttribute("data-process-i");
    attachFallback(im,i,"process");
    im.src = PROCESS_IMAGES[i];
  });

  document.querySelectorAll("[data-ring-i]").forEach(function(im){
    var i = +im.getAttribute("data-ring-i");

    if(!RING_IMAGES[i]){
      im.hidden = true;
      return;
    }

    attachFallback(im,i,"ring");
    im.src = RING_IMAGES[i];
  });

  var scrolly = document.getElementById("scrolly");
  var stagesEl = document.getElementById("stages");

  if(!scrolly || !stagesEl){
    return;
  }

  if(reduce){
    return;
  }

  stagesEl.style.display = "none";
  scrolly.hidden = false;

  var track = document.getElementById("track");
  var frame = document.getElementById("frame");
  var sweep = document.getElementById("sweep");
  var ringPreview = document.getElementById("ringPreview");
  var ringPreviewInner = document.getElementById("ringPreviewInner");
  var nodesEl = document.getElementById("nodes");
  var nodesLine = document.getElementById("nodesLine");
  var nodesFill = document.getElementById("nodesFill");
  var prev = document.getElementById("prev");
  var next = document.getElementById("next");
  var cue = document.getElementById("scrollcue");
  var cap = document.getElementById("cap");
  var capTitle = document.getElementById("capTitle");
  var capBody = document.getElementById("capBody");
  var kStage = document.getElementById("kStage");
  var kMeta = document.getElementById("kMeta");
  var live = document.getElementById("live");

  var processLayers = STAGES.map(function(s,i){
    var layer = document.createElement("div");
    layer.className = "layer" + (i === 0 ? " base" : "");

    var im = document.createElement("img");
    im.alt = "";
    im.loading = i > 1 ? "lazy" : "eager";
    attachFallback(im,i,"process");
    im.src = PROCESS_IMAGES[i];

    layer.appendChild(im);
    frame.insertBefore(layer,sweep);

    return layer;
  });

  var ringLayers = STAGES.map(function(s,i){
    var layer = document.createElement("div");
    layer.className = "ring-layer" + (i === 0 ? " base" : "");

    if(RING_IMAGES[i]){
      var im = document.createElement("img");
      im.alt = "";
      im.loading = i > 1 ? "lazy" : "eager";
      attachFallback(im,i,"ring");
      im.src = RING_IMAGES[i];
      layer.appendChild(im);
    }else{
      layer.setAttribute("data-empty","true");
    }

    ringPreviewInner.appendChild(layer);

    return layer;
  });

  var nodeBtns = STAGES.map(function(s,i){
    var button = document.createElement("button");
    button.type = "button";
    button.className = "node" + (i === 0 ? " is-active" : "");
    button.setAttribute("aria-label","Stage " + (i+1) + " of " + N + ": " + s.t);

    button.innerHTML =
      '<span class="node__ic">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
          s.ic +
        '</svg>' +
      '</span>' +
      '<span class="node__lbl"><span class="ix">' + (i+1) + '</span>' + s.lbl + '</span>';

    button.addEventListener("click",function(){
      scrollToStage(i);
    });

    nodesEl.appendChild(button);
    return button;
  });

  var SCROLL_PER = 1.3;   // viewport-heights of scroll per stage (more = gentler)
  var HOLD = 0.2;         // dwell at each stage; smaller = transition spread wider
  var active = -1;
  var curP = 0;

  // --- Smoothed scrubbing -------------------------------------------------
  // Scroll only sets a *target*. A rAF loop eases the rendered value toward it,
  // so the discrete steps a wheel/trackpad emits no longer show as hard jumps
  // between frames. SMOOTH is the easing strength, normalised to 60fps below.
  var targetP = 0;
  var renderP = 0;
  var rafId = null;
  var lastT = 0;
  var SMOOTH = 0.14;

  function sizeTrack(){
    track.style.height = (window.innerHeight * (1 + (N - 1) * SCROLL_PER)) + "px";
  }

  function layoutNodes(){
    var base = nodesEl.getBoundingClientRect();
    var icons = nodeBtns.map(function(button){
      return button.querySelector(".node__ic").getBoundingClientRect();
    });

    var firstCenter = icons[0].left + icons[0].width / 2 - base.left;
    var lastCenter = icons[N-1].left + icons[N-1].width / 2 - base.left;
    var top = icons[0].top + icons[0].height / 2 - base.top;

    nodesLine.style.left = firstCenter + "px";
    nodesLine.style.width = (lastCenter - firstCenter) + "px";
    nodesLine.style.top = top + "px";

    nodesFill.style.left = firstCenter + "px";
    nodesFill.style.top = top + "px";

    paintFill();
  }

  function paintFill(){
    var base = nodesEl.getBoundingClientRect();
    var first = nodeBtns[0].querySelector(".node__ic").getBoundingClientRect();
    var last = nodeBtns[N-1].querySelector(".node__ic").getBoundingClientRect();

    var firstCenter = first.left + first.width / 2 - base.left;
    var lastCenter = last.left + last.width / 2 - base.left;

    nodesFill.style.width = Math.max(0,(lastCenter - firstCenter) * (curP / (N - 1))) + "px";
  }

  function setActive(a){
    if(a === active){
      return;
    }

    active = a;

    var s = STAGES[a];

    cap.classList.add("is-out");

    window.setTimeout(function(){
      capTitle.textContent = s.t;
      capBody.textContent = s.b;
      kStage.textContent = "Stage " + (a + 1) + " / " + N;
      kMeta.textContent = s.m;
      cap.classList.remove("is-out");
    },150);

    nodeBtns.forEach(function(button,i){
      button.classList.toggle("is-active",i === a);
      button.setAttribute("aria-current",i === a ? "true" : "false");
    });

    prev.disabled = a <= 0;
    next.disabled = a >= N - 1;

    live.textContent = "Stage " + (a + 1) + " of " + N + ": " + s.t;
  }

  function render(pRaw){
    curP = pRaw;

    var idx = Math.floor(pRaw + 1e-6);
    var lt = pRaw - idx;

    if(idx >= N - 1){
      idx = N - 2;
      lt = 1;
    }

    if(idx < 0){
      idx = 0;
      lt = 0;
    }

    var travel = Math.max(.1,1 - HOLD * 2);
    var t = clamp((lt - HOLD) / travel,0,1);
    var e = ease(t);

    for(var k = 0; k < N; k++){
      var processLayer = processLayers[k];

      if(k === idx){
        processLayer.style.opacity = 1;
        processLayer.style.transform = "translateZ(0) scale(" + (1 + e * .02).toFixed(4) + ")";
        processLayer.style.filter = e > .002 ? "blur(" + (e * .8).toFixed(2) + "px)" : "none";
      }else if(k === idx + 1){
        processLayer.style.opacity = e.toFixed(3);
        processLayer.style.transform = "translateZ(0) scale(" + (1.04 - e * .04).toFixed(4) + ")";
        processLayer.style.filter = e < .998 ? "blur(" + ((1 - e) * 1.4).toFixed(2) + "px)" : "none";
      }else{
        processLayer.style.opacity = 0;
        processLayer.style.transform = "translateZ(0) scale(1.02)";
        processLayer.style.filter = "none";
      }
    }

    if(ringPreview){
      ringPreview.classList.toggle("is-empty", idx === 0 && e <= 0.001);
    }

    for(var r = 0; r < N; r++){
      var ringLayer = ringLayers[r];

      ringLayer.style.transform = "none";
      ringLayer.style.filter = "none";

      if(r === idx){
        ringLayer.style.opacity = (1 - e).toFixed(3);
      }else if(r === idx + 1){
        ringLayer.style.opacity = e.toFixed(3);
      }else{
        ringLayer.style.opacity = 0;
      }
    }

    if(t > 0.01 && t < 0.99){
      sweep.style.opacity = Math.sin(t * Math.PI).toFixed(3);
      sweep.style.transform = "translateX(" + (-60 + t * 330).toFixed(1) + "%) skewX(-9deg)";
    }else{
      sweep.style.opacity = 0;
    }

    paintFill();
    setActive(t < .5 ? idx : idx + 1);
  }

  function readScroll(){
    var total = track.offsetHeight - window.innerHeight;
    var f = total > 0 ? clamp(-track.getBoundingClientRect().top / total,0,1) : 0;

    targetP = f * (N - 1);

    if(cue){
      cue.style.opacity = Math.max(0,1 - f * 8);
    }

    startLoop();
  }

  function startLoop(){
    if(rafId === null){
      lastT = performance.now();
      rafId = requestAnimationFrame(loop);
    }
  }

  function loop(now){
    var dt = Math.min(48, now - lastT);   // cap dt so tab-switches don't jump
    lastT = now;

    // frame-rate independent exponential smoothing toward the scroll target
    var k = 1 - Math.pow(1 - SMOOTH, dt / (1000 / 60));
    renderP += (targetP - renderP) * k;

    if(Math.abs(targetP - renderP) < 0.0006){
      renderP = targetP;
      render(renderP);
      rafId = null;                        // settled — stop burning frames
      return;
    }

    render(renderP);
    rafId = requestAnimationFrame(loop);
  }

  function scrollToStage(i){
    i = clamp(i,0,N - 1);

    var total = track.offsetHeight - window.innerHeight;
    // Use the track's true position in the document. offsetTop is measured
    // against the nearest positioned ancestor (.scrolly is position:relative),
    // so it resolves to ~0 and would scroll toward the top of the page.
    var trackTop = track.getBoundingClientRect().top + window.pageYOffset;
    var top = trackTop + (i / (N - 1)) * total;

    window.scrollTo({
      top:top,
      behavior:"smooth"
    });
  }

  prev.addEventListener("click",function(){
    scrollToStage(Math.round(curP) - 1);
  });

  next.addEventListener("click",function(){
    scrollToStage(Math.round(curP) + 1);
  });

  nodesEl.addEventListener("keydown",function(e){
    var a = Math.round(curP);
    var handled = true;

    if(e.key === "ArrowRight" || e.key === "ArrowDown"){
      scrollToStage(a + 1);
      nodeBtns[clamp(a + 1,0,N - 1)].focus();
    }else if(e.key === "ArrowLeft" || e.key === "ArrowUp"){
      scrollToStage(a - 1);
      nodeBtns[clamp(a - 1,0,N - 1)].focus();
    }else if(e.key === "Home"){
      scrollToStage(0);
      nodeBtns[0].focus();
    }else if(e.key === "End"){
      scrollToStage(N - 1);
      nodeBtns[N - 1].focus();
    }else{
      handled = false;
    }

    if(handled){
      e.preventDefault();
    }
  });

  window.addEventListener("scroll",readScroll,{passive:true});

  window.addEventListener("resize",function(){
    sizeTrack();
    layoutNodes();
    readScroll();
  });

  sizeTrack();
  render(0);
  active = 0;
  targetP = 0;
  renderP = 0;

  requestAnimationFrame(function(){
    layoutNodes();
    readScroll();
  });
})();
})();
